// Base URL
export const BASE_URL = process.env.REACT_APP_BASE_URL + "/api/v1";
export const FILE_UPLOAD_BASE_URL = process.env.REACT_APP_BASE_URL;
export const NET_BASE_URL = process.env.REACT_APP_NET_BASE_URL
// Login URL
export const AUTH = '/user_management/admin/auth';
export const USER_LOGIN = AUTH + "/login";
export const USER_LOGOUT = AUTH + "/logout";
export const FORGOT_PASSWORD = AUTH + "/forgot_password";
export const RESET_PASSWORD = AUTH + "/password";
export const ADMIN = "/course/admin";

// Meta url
export const META_URL = '/meta';
export const SECTION_STUDENTS_META = `${META_URL}/admin/section_students`;

// Master url
export const MASTER_URL = '/Master'

// Admin course base
const ADMIN_COURSE = '/course/admin';

// Boards
export const BOARDS = ADMIN_COURSE + '/boards';
export const BOARDS_LIST = BASE_URL + "/meta/boards"


// Classrooms
export const CLASSROOMS = ADMIN_COURSE + '/class_rooms';

// Subjects
export const SUBJECTS = ADMIN_COURSE + '/subjects';

// Class room subjects
export const CLASSROOM_SUBJECTS = ADMIN_COURSE + '/class_room_subjects';

// Student
const STUDENT = '/Student';
export const STUDENT_REPORTS = '/StudentReport';
export const STUDENT_COURSES = "/course/student/student_courses";
export const SELF_REGISTERED_STUDENTS_LIST = STUDENT + '/SelfRegistered'
export const STUDENT_SUBSCRIPTIONS = STUDENT + '/Subscriptions'

//Chapters
export const CHAPTERS = ADMIN_COURSE + '/chaptors';
export const CHAPTER_CONTENTS = ADMIN_COURSE + '/chaptor_contents'
export const CHAPTER_CONTENTS_BULK = ADMIN_COURSE + '/chaptor_contents/bulk'

//Content library
export const CONTENT_LIBRARY = '/content_management/admin/content_libraries';
export const CONTENT_LIBRARY_QUESTIONS = ADMIN_COURSE + "/content_questions"
export const CONTENT_LIBRARY_QUESTION_ID = CONTENT_LIBRARY_QUESTIONS + "/:questionId"
export const BULK_CONTENT_QUESTIONS = CONTENT_LIBRARY + "/bulk_questions"
//Tutors
export const TUTORS = '/user_management/admin/tutors';

//Internal users
export const INTERNAL_USERS = '/user_management/admin/managers';

// Exercises
export const EXERCISES = ADMIN + "/excercises";
export const EXERCISES_ID = EXERCISES + "/:id";
export const EXERCISE_POSITION = EXERCISES_ID + "/position";
export const BULK_EXERCISE_QUESTIONS = EXERCISES + "/bulk_questions"
export const BULK_EXERCISE_QUESTIONS_DOC =  "/Content/ImportQuestion"

// Question
export const QUESTION = ADMIN + "/questions";
export const QUESTION_ID = QUESTION + "/:id";
export const QUESTION_ATTACHMENTS = ADMIN_COURSE + "/question_attachments"
export const SOLUTION_ATTACHMENTS = ADMIN_COURSE + "/question_solution_attachments"
export const QUESTION_OPTION_ATTACHMENTS = ADMIN_COURSE + "/question_option_images"

export const CONTENT_QUESTION_ATTACHMENTS = ADMIN_COURSE + "/content_question_attachments"
export const CONTENT_SOLUTION_ATTACHMENTS = ADMIN_COURSE + "/cont_quest_sol_atchmnts"
export const CONTENT_OPTION_ATTACHMENTS = ADMIN_COURSE + "/cont_quest_option_images"

export const EXAM_QUESTION_ATTACHMENTS = ADMIN_COURSE + "/exam_question_attachments"
export const EXAM_SOLUTION_ATTACHMENTS = ADMIN_COURSE + "/exam_question_solution_attachments"
export const EXAM_QUESTION_OPTION_ATTACHMENTS = ADMIN_COURSE + "/exam_question_option_images"


export const PAPER_QUESTION_ATTACHMENTS = ADMIN_COURSE + "/paper_question_attachments"
export const PAPER_SOLUTION_ATTACHMENTS = ADMIN_COURSE + "/paper_question_solution_attachments"
export const PAPER_QUESTION_OPTION_ATTACHMENTS = ADMIN_COURSE + "/paper_exam_question_option_images"


export const EXAMS_LIST = ADMIN_COURSE + '/exams';
export const EXAM_SUBJECTS_LIST = ADMIN_COURSE + "/exam_subjects"
export const EXAM_SUBJECT_CHAPTERS_LIST = ADMIN_COURSE + "/exam_chapters"
export const EXAM_SUBJECT_CHAPTER_EXERCISES_LIST = ADMIN_COURSE + "/exam_exercises"
export const EXAM_SUBJECT_CHAPTERS_CONTENTS_LIST = ADMIN_COURSE + "/exam_chapter_contents"
export const EXAM_SUBJECT_CHAPTERS_EXERCISES_QUESTION = ADMIN_COURSE + "/exam_questions"
export const BULK_EXAM_EXERCISE_QUESTIONS = EXAM_SUBJECT_CHAPTER_EXERCISES_LIST + "/bulk_questions"


export const PREVIOUS_PAPER_LIST = ADMIN_COURSE + "/papers"
export const PREVIOUS_PAPER_QUESTIONS = ADMIN_COURSE + "/paper_questions"
export const PREVIOUS_PAPER_QUESTION_ID = PREVIOUS_PAPER_QUESTIONS + "/:id"
export const PREVIOUS_PAPER_ID = PREVIOUS_PAPER_LIST + "/:id"
export const BULK_PAPER_QUESTIONS = PREVIOUS_PAPER_LIST + "/bulk_questions"

// Institute
export const INSTITUTE_MANAGEMENT = "/institute_management/admin"
export const INSTITUTES_LIST = INSTITUTE_MANAGEMENT + "/institutes"
export const SINGLE_INSTITUTE = INSTITUTES_LIST + "/:instituteId"
export const BRANCHES_LIST = INSTITUTE_MANAGEMENT + "/branches"
export const SINGLE_BRANCH = BRANCHES_LIST + "/:branchId"
export const BRANCH_CLASSROOMS_LIST = META_URL + "/branch_class_rooms"
export const BRANCH_SECTIONS = META_URL + "/sections"
export const SECTIONS_LIST = INSTITUTE_MANAGEMENT + "/sections"
export const SINGLE_SECTION = SECTIONS_LIST + "/:sectionId"
export const STUDENTS_LIST = INSTITUTE_MANAGEMENT + "/students"
export const PRIVATE_STUDENTS = INSTITUTE_MANAGEMENT + "/private_students"
export const SINGLE_STUDENT = STUDENTS_LIST + "/:studentId"
export const PRIVATE_SINGLE_STUDENT = PRIVATE_STUDENTS + "/:studentId"
export const STUDENT_PASSWORD_UPDATE = SINGLE_STUDENT + "/password_update"
export const PRIVATE_STUDENT_PASSWORD_UPDATE = PRIVATE_SINGLE_STUDENT + "/password_update"
export const EXISITING_STUDENT_DATA = STUDENTS_LIST + "/download_xls.xls"
export const EXISITING_STUDENT_PRIVATE_DATA = PRIVATE_STUDENTS + "/download_xls.xls"
export const INSTITUTE_STUDENT__DETAILS = STUDENTS_LIST + "/:studentId/details"
// export const INSTITUTE_LEADERBOARD = STUDENTS_LIST + "/:studentId/leaderboard"
export const INSTITUTE_LEADERBOARD = STUDENT_REPORTS + "/GetLeaderBoardByStudentCourse"
export const SECTION_SUBJECTS = META_URL + "/section_subjects"
export const BRANCHES_META = META_URL + "/branch"
export const INSTITUTES_META = META_URL + "/institute"
export const BOARDS_META = META_URL + "/boards"
export const EXAMS_META = META_URL + "/exams"
export const CLASSROOMS_META = META_URL + "/class_room"
export const INSTITUTE_TUTORS = INSTITUTE_MANAGEMENT + "/tutors"
export const INSTITUTE_TUTOR_DETAILS = INSTITUTE_TUTORS + "/:tutorId"
export const INSTITUTE_TUTOR_PASSWORD_UPDATE = INSTITUTE_TUTOR_DETAILS + "/password_update"
export const INSTITUTE_TUTORS_BULK = INSTITUTE_TUTORS + "/bulk"
export const INSTITUTE_TUTORS_EXISITING_DATA = INSTITUTE_TUTORS + "/download_xls.xls"
export const INSTITUTE_LIVE_CLASS_CREATE = INSTITUTE_MANAGEMENT + "/live_classes"
export const INSTITUTE_LIVE_CLASSES = SINGLE_INSTITUTE + "/live_classes"
export const INSTITUTE_LIVE_CLASS = INSTITUTE_LIVE_CLASS_CREATE + "/:liveClassId"
export const INSTITUTE_BRANCHES_META = META_URL + "/admin/branches"
export const INSTITUTE_SECTIONS_META = META_URL + "/sections"
export const INSTITUTE_TUTORS_META = META_URL + "/admin/tutors"
export const INSTITUTE_SECTION_SUBJECTS_META = META_URL + "/admin/subjects"
export const LIVE_CLASS_JOIN_NEW = '/Tutor/JoinLiveClass'
export const LIVE_CLASS_CREATE_UPDATE = '/Tutor/InsertUpdateLiveClass'

//Leaderboard
export const LEADERBOARD_CLASSROOM_BYINST = "/LeaderBoard/BoardLearderByInst"
export const LEADERBOARD_CLASSROOM_BYONBOARD = "/LeaderBoard/BoardLearderByOnboard"
export const LEADERBOARD_EXAM = "/leaderboard/admin/exam_leaderboard"

//Dashboard
export const DASHBOARD = "/dashboard/admin/admin_analytics"
export const _DASHBOARD = "/dashboard"
export const DASHBOARD_CONTENT_ACCESSED = DASHBOARD + "/content_accessed"
export const DASHBOARD_STUDENT_METRICS = DASHBOARD + "/metrics"
export const DASHBOARD_TUTOR_ACTIVITIES = DASHBOARD + "/tutor_activities"

export const DOWNLOAD_CONTENT_METRICS = _DASHBOARD + "/GetContentInfo "
export const DASHBOARD_STUDENT_STATUS = _DASHBOARD + "/GetStudentStatus"
export const DASHBOARD_STUDENT_ACTIVITIES = _DASHBOARD + "/GetStudentActivities"
export const DASHBOARD_STUDENT_PERFORMANCE = _DASHBOARD + "/GetStudentPerformance"
export const DASHBOARD_STUDENT_PERFORMANCE_BY_GRADE = _DASHBOARD + "/GetStudentPerformanceByGrade"
export const DOWNLOAD_STUDENT_PERFORMANCE_BY_GRADE = _DASHBOARD + "/GetStudentPerformanceByGradeDownload"
export const DASHBOARD_LOGIN_REPORT = _DASHBOARD + "/GetLoginReport"
export const STUDENT_LOGIN_REPORT = _DASHBOARD + "/GetStudentLoginReport"
export const DASHBOARD_TUTOR_LOGIN_REPORT = _DASHBOARD + "/GetTutorsLoginReport"
export const DASHBOARD_MOST_DISLIKED_CONTENT = _DASHBOARD + "/GetRankedContent"
export const DASHBOARD_MOST_LIKED_CONTENT = _DASHBOARD + "/GetRankedContent"
export const DASHBOARD_MOST_WATCHED_CONTENT = _DASHBOARD + "/GetRankedContent"
export const DASHBOARD_MOST_ATTEMPTED_QUIZ = _DASHBOARD + "/GetRankedContent"

// Master
export const BOARDS_MASTER = MASTER_URL + "/GetActiveBoards"
export const INSTITUTES_MASTER = MASTER_URL + "/GetActiveInstitutes"
export const BRANCHES_MASTER = MASTER_URL + "/GetActiveInstBranch"
export const GRADE_MASTER = MASTER_URL + "/GetActiveBranchGrades"
export const SECTIONS_MASTER = MASTER_URL + "/GetBranchClassSections"
export const SUBJECTS_MASTER = MASTER_URL + "/GetClassSubjects"
export const CHAPTERS_MASTER = MASTER_URL + "/GetClassSubjectsChapter"
export const GRADE_MASTER_BY_BOARD = MASTER_URL + "/GetClassRoomsByBoard"


//Analytics URL
export const ANALYTICS_CLASS = STUDENT_COURSES + "/:courseId/student_class_results/view"
export const ANALYTICS_CLASS_PROGRESS = STUDENT_REPORTS + "/GetProgressByStudentCourse"
export const ANALYTICS_SUBJECTS = STUDENT_COURSES + "/:courseId/class_room_subjects/:subjectId/student_subject_results/view"
export const ANALYTICS_CHAPTERS = STUDENT_COURSES + "/:courseId/chaptors/:chapterId/student_chapter_results/view"
export const ANALYTICS_EXERCISES = ANALYTICS_CHAPTERS + "/:courseId/excercise_attempts/:attemptId/exercise_attempt_results/:attemptResultId"
export const ANALYTICS_EXERCISES_ATTEMPTS = STUDENT_COURSES + "/:courseId/excercise_attempts/:attemptId/exercise_attempt_results"
export const ANALYTICS_QUICK_QUIZ = STUDENT_COURSES + "/:courseId/content_exercise_attempts/:attemptId/content_exercise_attempt_results"

export const ANALYTICS_EXAM = STUDENT_COURSES + "/:courseId/exam_results/view"
export const ANALYTICS_SUBJECTS_EXAM = STUDENT_COURSES + "/:courseId/exam_subjects/:subjectId/exam_subject_results/view"
export const ANALYTICS_CHAPTERS_EXAM = STUDENT_COURSES + "/:courseId/exam_chapters/:chapterId/exam_chapter_results/view"
export const ANALYTICS_EXERCISES_ATTEMPTS_EXAM = STUDENT_COURSES + "/:courseId/exam_exercise_attempts/:attemptId/exam_exercise_attempt_results"
export const ANALYTICS_QUICK_QUIZ_EXAM = STUDENT_COURSES + "/:courseId/exam_exercise_attempts/:attemptId/exam_exercise_attempt_results"
export const ANALYTICS_PAPER_ATTEMPTS = STUDENT_COURSES + "/:courseId/paper_attempts/:attemptId/paper_attempt_results"
export const ANALYTICS_PAPER = STUDENT_COURSES + "/:courseId/exam_paper_results/view"

// Reports
const REPORT='/Report'
export const ACTIVITY_SUMMARY = REPORT + "/GetAdminActivitySummary"
export const DOWNLOAD_ACTIVITY_SUMMARY = REPORT + "/DownloadAdminActivityDetails"
export const ACTIVITY_SUBMISSION_DETAILS = REPORT + "/GetActivitySubmissionDetails"

export const TEACHER_ACTIVITY_SUMMARY = REPORT + "/GetTeacherActivitySummary"
export const DOWNLOAD_TEACHER_ACTIVITY_SUMMARY = REPORT + "/DownloadTeacherActivitySummary"

export const LOGIN_ACTIVITY_SUMMARY = REPORT + "/GetLoginActivityReport"
export const DOWNLOAD_LOGIN_ACTIVITY_SUMMARY = REPORT + "/GetLoginActivityReportDownload"

export const CHAPTERWISE_SUMMARY = REPORT + "/GetChapterwiseReport"
export const DOWNLOAD_CHAPTERWISE_SUMMARY = REPORT + "/GetChapterwiseReportDownload"


// Products
const PRODUCT="/Product"
export const PRODUCT_LIST=PRODUCT+"/GetProductList"
export const CREATE_PRODUCT=PRODUCT+"/CreateProduct"
export const UPDATE_PRODUCT=PRODUCT+"/UpdateProduct"
export const SALES_REPORT="api/Store/Store/SalesReport"
export const DOWNLOAD_SALES_REPORT='/api/Store/Store/DownloadSalesReport'

// Reports
const REPORTS_URL = '/reports';
const ADMIN_REPORTS = `${REPORTS_URL}/admin`
const ADMIN_ZOOM_REPORTS = `${ADMIN_REPORTS}/zoom_reports`
export const ADMIN_ZOOM_MEETING_PARTICIPANTS = `${ADMIN_ZOOM_REPORTS}/meeting_participants.xls`
export const DOWNLOAD_CHAPTERWISE_REPORT = `${REPORTS_URL}/chapter_wise_report/download`
export const CHAPTERWISE_REPORT = `${REPORTS_URL}/chapter_wise_report`
